import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Data } from 'signup-constants/signupData/Data';
import { bulkEmptySignupDataAndSetFresh, setSignupDataValue } from '../store/signup-data/action-creators';
import { useOldSignupEmail } from '../step-resend-email/useOldSignupEmail';
import { useSignupData } from '../signup-data/useSignupData';
import { useEmailVerification } from '../http-initiate-verification/useEmailVerification';
export const useResendEmail = () => {
  const dispatch = useDispatch();
  const resendButtonClickedRef = useRef(false);

  // Get the values directly in the hook
  const {
    oldEmail
  } = useOldSignupEmail();
  const {
    isValid: isEmailValid
  } = useSignupData(Data.Email);
  const {
    resendEmail
  } = useEmailVerification();
  const resend = () => {
    if (isEmailValid) {
      resendButtonClickedRef.current = true;
      dispatch(bulkEmptySignupDataAndSetFresh([Data.CodeVerification]));
      resendEmail();
    }
  };
  useEffect(() => {
    // This function is called when this component/hook is unmounted (Cleanup function)
    // It restores the original value of EMAIL if user never clicked ResendButton
    // Ref stores the value if button was clicked or not
    return () => {
      if (!resendButtonClickedRef.current && oldEmail !== '') {
        dispatch(setSignupDataValue(Data.Email, oldEmail));
      }
    };
  }, [dispatch, oldEmail]);
  return {
    resend,
    isEmailValid
  };
};